// Module
var code = `<li><a href> </a></li>`;
// Exports
export default code;